import { isAccountFeatureEnabled } from "owa-feature-flags";
import type { MailboxInfo } from "owa-client-types";
import { SubstrateSearchScenario } from "../data/schema/SubstrateSearchScenario";
import type SubstrateSearchEndpointTarget from "../data/schema/SubstrateSearchEndpointTarget";

type SubstrateSearchEndpoint = "suggestions" | "events" | "init" | "query" | "searchHistory" | "feedback" | "usercontrols";

export const GENWEB_SEARCH_ENDPOINT_PREFIX = "/messageservice/genwebsearch/";

export function getSubstrateSearchEndpointTarget(endpoint: SubstrateSearchEndpoint, scenario?: SubstrateSearchScenario, mailboxInfo?: MailboxInfo, endpointTarget: SubstrateSearchEndpointTarget = "Auto"): Exclude<SubstrateSearchEndpointTarget, "Auto"> {
    const supportsGenWeb = scenario === SubstrateSearchScenario.Mail &&
        (endpoint === "events" ||
            endpoint === "init" ||
            endpoint === "suggestions" ||
            endpoint === "query");
    
    return supportsGenWeb &&
        (endpointTarget === "GenWeb" ||
            (endpointTarget === "Auto" &&
                !!mailboxInfo &&
                isAccountFeatureEnabled("sea-gwc-outlook-infra-latency-testing", mailboxInfo)))
        ? "GenWeb"
        : "3S";
}

export default function getSubstrateSearchEndpoint(endpoint: SubstrateSearchEndpoint, version?: number, scenario?: SubstrateSearchScenario, mailboxInfo?: MailboxInfo, endpointTarget: SubstrateSearchEndpointTarget = "Auto"): string {
    const isGenWebEndpoint = getSubstrateSearchEndpointTarget(endpoint, scenario, mailboxInfo, endpointTarget) ===
        "GenWeb";
    
    if (isGenWebEndpoint) {
        return `${GENWEB_SEARCH_ENDPOINT_PREFIX}${endpoint}`;
    }
    
    const versionPath = version === 3 ? "v3" : version === 2 ? "v2" : "v1";
    // Calendar query v2 and v3 both warm up through /searchservice/api/v2/init.
    const isCalendarInitEndpoint = endpoint == "init" &&
        scenario == SubstrateSearchScenario.Calendar &&
        (version == 2 || version == 3);
    const searchPath = endpoint == "query" || isCalendarInitEndpoint ? "searchservice" : "search";
    
    return `${searchPath}/api/${versionPath}/${endpoint}`;
}
